// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-1fa93594]:export{siteFontFamily:system-ui,sans-serif,math,ui-rounded,ui-monospce}.coupon-dialog .list-area[data-v-1fa93594]{height:300px}.coupon-dialog .confirm-btn[data-v-1fa93594]{align-items:center;background-color:#3f54f2;border-radius:2px;color:#fff;cursor:pointer;display:flex;height:32px;justify-content:center;margin:0 auto;width:100px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
